import React, { useState, useEffect, useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function SliderCabs({ section }) {
  const [isScrolled, setIsScrolled] = useState(false);

  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    centerMode: true,
    centerPadding: "0",
    responsive: [
      {
        breakpoint: 1200, // For screens smaller than 1200px
        settings: {
          slidesToShow: 3, // Show 3 slides
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 992, // For screens smaller than 992px
        settings: {
          slidesToShow: 3, // Show 2 slides
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768, // For screens smaller than 768px
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 320, // For screens smaller than 320px
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const handleScroll = () => {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    if (scrollTop > 50) {
      setIsScrolled(true);
    } else {
      setIsScrolled(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const fallbackItems = [
    { image_url: 'assets/img/cabs/exclusive-offers/1.png', description: 'Get flat 10% OFF* on ride with outstation one way or round trip cab bookings', subtitle: 'Valid till: 30th Nov, 2024' },
    { image_url: 'assets/img/cabs/exclusive-offers/1.png', description: 'Get flat 10% OFF* on ride with outstation one way or round trip cab bookings', subtitle: 'Valid till: 30th Nov, 2024' },
    { image_url: 'assets/img/cabs/exclusive-offers/1.png', description: 'Get flat 10% OFF* on ride with outstation one way or round trip cab bookings', subtitle: 'Valid till: 30th Nov, 2024' },
    { image_url: 'assets/img/cabs/exclusive-offers/1.png', description: 'Get flat 10% OFF* on ride with outstation one way or round trip cab bookings', subtitle: 'Valid till: 30th Nov, 2024' },
  ];
  const items = section?.Items?.length ? section.Items : fallbackItems;

  return (
    <section className="container">
      
      <div
        className={`customer-logos slider slides-wrapper slider-width ${
          isScrolled ? "slider" : ""
        }`}
      >
        <Slider {...settings}>
        {items.map((item, index) => (
          <div className="exclusive-offers-img-sec" key={`${item.image_url}-${index}`}>
            <img src={item.image_url} alt={item.title || 'Offer'} />
            <div className="_offrdtl">{item.description || item.title}</div>
            <div className="_offrdate">{item.subtitle || item.badge_text}</div>
          </div>
        ))}
        </Slider>
      </div>
      <style>{`
        @media (min-width: 769px) {
          .cabs-page .slick-track {
            width: 3660px !important;
          }
        }

        @media (max-width: 768px) {
          .cabs-page .cabs-exclusive-slider .slick-track {
            width: 370px !important;
          }

        }
      `}</style>
    </section>
  );
}

export default SliderCabs;
